/**
 * ObjectColorField React component
 * 
 * @author    Maurizio Tidei, Jens Gruschel
 * @copyright © 2018 contexagon GmbH
 */


// React
import React from 'react';
import PropTypes from 'prop-types';

// Material UI
import {withStyles} from "@material-ui/core";

// Material UI components
import InputLabel from '@material-ui/core/InputLabel';

// 3rd party components
import {ChromePicker, SwatchesPicker} from 'react-color';


/**
 * ObjectColorField is an editing component for color fields of objects
 *
 * @author Maurizio Tidei, Jens Gruschel
 */
export class ObjectColorField extends React.Component {

    render() {

        const { classes } = this.props;

        return <div className={classes.colorDiv}>
            <InputLabel shrink={true} className={classes.colorLabel}>{this.props.fieldDef.name}</InputLabel>
            <div style={{width:"100%",height:"30px", borderRadius:"3px 3px 3px 3px", marginBottom:5, backgroundColor:this.props.value}}/>
            <div style={{display:"inline-flex"}}>
                <ChromePicker color={this.props.value} disableAlpha={true}
                    onChangeComplete={color => this.props.onObjectValueChange(this.props.fieldDef.id, color.hex)}
                    styles={{
                        default:{
                            picker:{
                                boxShadow:"none",
                                marginRight:20,
                                marginTop:15,
                                width:226,
                                minWidth:226,
                                border:"1px solid #e6e6e6",
                                borderRadius:4
                            }
                        }
                    }}/>
                <SwatchesPicker color={this.props.value}
                    onChangeComplete={color => this.props.onObjectValueChange(this.props.fieldDef.id, color.hex)}
                    styles={{
                        default:{
                            picker:{
                                width:"100p%"
                            },
                            overflow:{
                                boxShadow:"none",
                                overflowY:"auto"
                            }
                        }
                    }}/>
            </div>
        </div>;
    }
}

ObjectColorField.propTypes = {
    onObjectValueChange: PropTypes.func.isRequired,
    fieldDef: PropTypes.object.isRequired,
    objectId: PropTypes.string,
    readOnly: PropTypes.bool,
    value: PropTypes.any
};

const styles = {
    colorDiv: {
        marginTop: 16,
        marginBottom: 8,
        display: "inline-grid",
        width: "100%"
    },
    colorLabel: {
        marginBottom: 8
    }
};

export default withStyles(styles)(ObjectColorField);